import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <div className="relative">
        <h1 className="text-8xl md:text-[10rem] font-black text-background-200 select-none pointer-events-none">
          404
        </h1>
        <div className="relative -mt-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Page Not Found
          </h2>
          <p className="text-sm text-foreground-600 font-mono mb-4">
            {location.pathname}
          </p>
          <p className="text-foreground-500 mb-8 max-w-md mx-auto">
            The page you are looking for does not exist. It might have been moved or deleted.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-line text-sm"></i>
            </div>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}